module.exports = __webpack_public_path__ + "milly.jpg";